module.exports = __webpack_public_path__ + "static/media/InternSupply.0dfa5521.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/InternSupply.png
// module id = 45
// module chunks = 0